module.exports = __webpack_public_path__ + "img/redeem.7b0ad514.svg";